export default __webpack_public_path__ + "static/media/Twitter.aedcb58c.svg";